<template>
  <div class="w-100 w-md-75 p-4">
    <div class="question-container mb-4">
      <!-- Question -->
      <h4 class="question-text mb-4" style="white-space: pre-wrap">
        {{ quiz?.questionText }}
      </h4>

      <!-- Essay Textarea -->
      <div class="form-group">
        <label for="essayAnswer" class="mb-2 font-weight-bold">
          {{ answerLabel }}
        </label>
        <textarea
          id="essayAnswer"
          v-model="displayAnswer"
          class="form-control essay-answer"
          :class="{ 'essay-answer--readonly': isReadonly }"
          rows="6"
          :placeholder="answerPlaceholder"
          :readonly="isReadonly"
        ></textarea>
      </div>

      <!-- Input Nilai (Hanya tampil saat grading guru, TIDAK tampil saat preview exam) -->
      <div class="form-group my-4 score-group" v-if="isGradingView">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label for="score" class="mb-0 font-weight-bold">
            Nilai (0–100)
          </label>
          <span class="small text-muted">Wajib diisi untuk menyelesaikan</span>
        </div>
        <div class="input-group score-input-group" style="max-width: 200px">
          <input
            id="score"
            type="number"
            class="form-control"
            v-model.number="score"
            min="0"
            max="100"
            step="1"
            placeholder="0–100"
            aria-describedby="scoreHint"
          />
          <span class="input-group-text">/ 100</span>
        </div>
        <p id="scoreHint" class="form-text mb-0 mt-1">
          Masukkan skor antara 0 dan 100.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useExamDataStore } from "@/stores/exam/exam-data-store";
import { useAuthStore } from "@/stores/auth-store";
import { computed } from "vue";

export default {
  name: "EssayQuestion",
  props: {
    quiz: {
      type: Object,
      required: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answer: "",
    };
  },

  setup(props) {
    const examStore = useExamDataStore();
    const authStore = useAuthStore();

    const isGradingView = computed(
      () => authStore.role === "teacher" && !props.preview
    );

    const isStaffView = computed(
      () =>
        authStore.role === "teacher" ||
        authStore.role === "principal" ||
        props.preview
    );

    const isReadonly = computed(
      () =>
        props.preview ||
        authStore.role === "teacher" ||
        authStore.role === "principal"
    );

    const answerLabel = computed(() => {
      if (props.preview) return "Jawaban essay (Preview):";
      if (isStaffView.value) return "Jawaban siswa:";
      return "Jawaban Anda:";
    });

    const answerPlaceholder = computed(() => {
      if (props.preview)
        return "Kolom ini akan diisi oleh jawaban siswa saat ujian berlangsung.";
      if (isStaffView.value) return "Tidak ada jawaban dari siswa.";
      return "Ketik jawaban Anda di sini...";
    });

    // Ambil jawaban lama dari store (kalau ada)
    const displayAnswer = computed({
      get: () => {
        if (props.preview) {
          return props.quiz?.answer || "";
        }
        if (authStore.role === "teacher" || authStore.role === "principal") {
          return props.quiz?.answer || ""; // tampilkan jawaban siswa
        } else {
          // student → ambil dari store
          const item = examStore.examAnswer?.find(
            (a) =>
              String(a.question) ===
              String(props.quiz?.questionID || props.quiz?.question)
          );
          return item ? item.answer : "";
        }
      },
      set: (val) => {
        if (!props.preview && authStore.role === "student") {
          examStore.setAnswer(
            props.quiz?.questionID || props.quiz?.question,
            val
          );
        }
      },
    });

    const score = computed({
      get: () => {
        if (isGradingView.value) {
          const item = examStore.essayScore.find(
            (s) =>
              String(s.question) ===
              String(props.quiz?.question || props.quiz?.questionID)
          );
          return item ? item.score : null;
        }
        return null;
      },
      set: (val) => {
        if (isGradingView.value) {
          examStore.setScore(
            props.quiz?.question || props.quiz?.questionID,
            val
          );
          examStore.saveScoring();
        }
      },
    });

    return {
      examStore,
      authStore,
      displayAnswer,
      score,
      isReadonly,
      isGradingView,
      answerLabel,
      answerPlaceholder,
    };
  },

  methods: {},
};
</script>

<style scoped>
textarea.form-control:focus,
.score-input-group .form-control:focus {
  border-color: #ff4667;
  box-shadow: 0 0 0 0.2rem rgba(255, 70, 103, 0.25);
}

.essay-answer--readonly {
  background-color: #f8f9fa;
  cursor: default;
}

.score-group .input-group-text {
  background-color: #fff0f3;
  color: #b91c3a;
  border-color: #ced4da;
  font-weight: 600;
}
</style>
